export const prices = {
  advancedPricingActive: "Erweiterte Preise importieren",
  advancedPricingActiveHelp:
    "Hier werden alle Verkaufspreise mit Kundengruppen, Staffelpreise, verschiedene Währungen und deren Gültigkeit importiert, sofern die Kundengruppen und Währungen zugeordnet wurden.",
  currencyAssignmentHelp:
    "Hier können die Währungen aus Xentral den entsprechenden Währungen in {appName} zugeordnet werden.",
  customerGroupAssignmentStrategy:
    "Wie sollen die erweiterten Preise zugeordnet werden?",
  customerGroupAssignmentStrategyCustomerGroup:
    "Kundengruppen aus Xentral den Kundengruppen im Verkaufskanal zuordnen",
  customerGroupAssignmentStrategyPriceRule:
    "Kundengruppen aus Xentral den Preisregeln im Verkaufskanal zuordnen",
  customerGroupAssignmentTableId: "Kundengruppenzuordnung",
  customerGroupAssignmentTableIdHelp:
    "Hier können die Kundengruppen aus Xentral den entsprechenden Kundengruppen in {appName} zugeordnet werden. Eine Kundengruppe aus Xentral kann dabei jeweils nur einer Kundengruppe in {appName} zugewiesen werden.",
  priceGroup: "Kunde bzw. Kundengruppe",
  priceGroupHelp:
    "Hier legst du fest, welcher Preis von Xentral in den Verkaufskanal übertragen wird. Trage dazu den Namen des Kunden oder der Kundengruppe ein. Lässt du das Feld leer, gilt der Standardpreis. Wenn du einen Kunden oder eine Kundengruppe einträgst, wird ausschließlich deren Preis übernommen – ein Fallback auf den Standardpreis erfolgt nicht.",
  priceRulesAssignmentTableId: "Zuordnung der Preisregeln",
  priceRulesAssignmentTableIdHelp:
    "Hier können die Kundengruppen aus Xentral den entsprechenden Preisregeln in {appName} zugeordnet werden. Eine Kundengruppe aus Xentral kann dabei jeweils nur einer Preisregel in {appName} zugewiesen werden.",
  roundPrices: "Preise vor der Übertragung in den Verkaufskanal runden?",
  roundPricesHelp:
    "Hier kannst du auswählen, ob Preise vor der Übertragung in den Verkaufskanal gerundet werden sollen. Dies kann mögliche Rundungsdifferenzen eliminieren.",
  transferGraduatedPrices: "Staffelpreise übertragen",
  transferNetPrice: "Preise als netto übertragen"
};
